import { render } from "./Galerie.vue?vue&type=template&id=b10ae214"
import script from "./Galerie.vue?vue&type=script&lang=js"
export * from "./Galerie.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GIT-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__